import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * The archive list's retired address. The Completed tab of the Work page IS
 * the archive now, so a saved deep link — a rejection banner's resubmit
 * target, a receipt a tester kept — arrives there with the tab pre-selected.
 * The DETAIL route at /history/$submissionId keeps its path; only the list
 * address moved.
 */
export const Route = createFileRoute("/_company/history/")({
  beforeLoad: () => {
    throw redirect({ to: "/my-work", search: { tab: "completed" } });
  },
});
